export { default as default } from './TabsCustom';
